import React from "react";
import styled from "styled-components";
import { IconBase, type IconProps } from "./IconBase";
import loadingSpinnerSVG from "images/icons/loading_spinner.svg";

export const StyledLoadingSpinnerIcon = styled(IconBase)<IconProps>`
  @keyframes spinnerSpin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  animation: spinnerSpin 1s infinite cubic-bezier(0.35, 0.3, 0.3, 0.35);
`;

export const LoadingSpinnerIcon = (props: IconProps) => {
  return <StyledLoadingSpinnerIcon {...props} href={loadingSpinnerSVG} />;
};
